import { Route } from "@angular/router";
import { ReadyRequestsComponent } from "./ready-requests.component";

export const readyRequestsRouting: Route = {
  path: 'ready',
  component: ReadyRequestsComponent
}
